<template>
  <div>
    <b-alert show variant="warning"><a href="#" class="alert-link"><i class="fas fa-exclamation-circle"></i> {{comunicado}}</a></b-alert>
  </div>
</template>
<script>
  export default {
    name: 'CardVue',
    props: ['title', 'header', 'comunicado']
  }
</script>
<style scoped>
  .fa-exclamation-circle{
    color: #c5241a;
  }
  i{
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/ComunicadoVue.vue